import type { HierarchicalCategory } from "../productSelectors";

/**
 * Recursively finds a category by its ID within a tree structure.
 * @param id - The ID of the category to find.
 * @param tree - The array of categories to search through.
 * @returns The found category object or null if not found.
 */
export const findCategoryInTree = (
  id: number,
  tree: HierarchicalCategory[]
): HierarchicalCategory | null => {
  for (const category of tree) {
    if (category.id === id) {
      return category;
    }
    const foundInChildren = findCategoryInTree(id, category.children);
    if (foundInChildren) {
      return foundInChildren;
    }
  }
  return null;
};

/**
 * Recursively gets all descendant IDs (children, grandchildren, etc.) of a category.
 * @param category - The category object from which to start.
 * @returns A flat array of all descendant IDs.
 */
export const getDescendantIds = (category: HierarchicalCategory): number[] => {
  let ids = category.children.map((child) => child.id);
  category.children.forEach((child) => {
    ids = [...ids, ...getDescendantIds(child)];
  });
  return ids;
};
